import Forward from '@sats-group/icons/16/forward';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import type { LinksBlock as Props } from './links-block.types';

const LinksBlock: React.FC<Props> = ({
  description,
  eyebrow,
  links,
  title,
}) => (
  <section className="links-block">
    <div className="links-block__header">
      {eyebrow ? (
        <Text
          className="links-block__eyebrow"
          size={Text.sizes.basic}
          theme={Text.themes.normal}
        >
          {eyebrow}
        </Text>
      ) : null}
      <Text
        className="links-block__title"
        elementName="h2"
        size={Text.sizes.headline1}
        theme={Text.themes.emphasis}
      >
        {title}
      </Text>
      {description ? (
        <Text
          className="links-block__description"
          elementName="p"
          size={Text.sizes.basic}
          theme={Text.themes.normal}
        >
          {description}
        </Text>
      ) : null}
    </div>
    <ol className="links-block__links">
      {links.map((link, index) => (
        <li key={link.href}>
          <a className="links-block__link" href={link.href}>
            <span aria-hidden className="links-block__number">
              <Text
                size={Text.sizes.interface}
                theme={Text.themes.normal}
                tight
              >
                {String(index + 1).padStart(2, '0')}
              </Text>
            </span>
            <Text
              className="links-block__text"
              size={Text.sizes.headline3}
              theme={Text.themes.normal}
            >
              {link.text}
            </Text>
            <span aria-hidden className="links-block__icon">
              <Forward />
            </span>
          </a>
        </li>
      ))}
    </ol>
  </section>
);

export default LinksBlock;
